import { TextInput } from 'react-admin'
import { styled } from '@mui/material'

const FilterInput = styled(TextInput)`
  width: 36vw;
`

export default FilterInput
